import type { Tenant } from "@/types";

/**
 * Tenant fixtures for the Auth flow only. Kept separate from the shared
 * `data/mock.ts` dataset (which is seeded under a fictional customer name)
 * so Auth never depends on — and can't accidentally leak — customer-specific
 * mock data. Names here must stay provider-neutral.
 */
export const AUTH_TENANTS: Tenant[] = [
  {
    id: "tenant-alloy-prod",
    name: "Alloy Digital Assets",
    initials: "AD",
    bgColor: "var(--ads-primary)",
    lastUsed: "Today, 9:42 AM",
    roleLabel: "Org Admin",
    envs: [{ name: "Production", production: true }, { name: "Sandbox", production: false }],
  },
  {
    id: "tenant-meridian",
    name: "Meridian Capital",
    initials: "MC",
    bgColor: "var(--ads-success)",
    lastUsed: "Yesterday, 4:10 PM",
    roleLabel: "Treasury Operator",
    envs: [{ name: "Sandbox", production: false }],
  },
  {
    id: "tenant-alloy-test",
    name: "Alloy Digital Assets (Testnet)",
    initials: "AD",
    bgColor: "var(--ads-warning)",
    lastUsed: "Sep 10, 2:30 PM",
    roleLabel: "Developer",
    envs: [{ name: "Testnet", production: false }],
  },
];
